import { render, staticRenderFns } from "./ReportStatsCard.vue?vue&type=template&id=ad59b39a&"
import script from "./ReportStatsCard.vue?vue&type=script&lang=js&"
export * from "./ReportStatsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad59b39a')) {
      api.createRecord('ad59b39a', component.options)
    } else {
      api.reload('ad59b39a', component.options)
    }
    module.hot.accept("./ReportStatsCard.vue?vue&type=template&id=ad59b39a&", function () {
      api.rerender('ad59b39a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/ReportStatsCard.vue"
export default component.exports